
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'WHO_HumanSemen',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WHO_HumanSemen.vue